<script>
    import { sanitizeHtml } from "../../sanitize.js";

    export let isFlipped = false;
    export let frontContent = "";
    export let backContent = "";
    export let frontImages = [];
    export let backImages = [];
    export let frontAudio = null;
    export let onFlip = () => {};

    // Track if we should use fallback URL for audio
    let audioUseFallback = false;

    // Reset fallback state when frontAudio changes
    $: if (frontAudio) {
        audioUseFallback = false;
    }

    $: currentAudioUrl = frontAudio
        ? (audioUseFallback ? frontAudio.url : (frontAudio.urlCachePWA || frontAudio.url))
        : null;

    function handleImageError(event, fallbackUrl) {
        console.warn("fallback to temp url", fallbackUrl, event.target.src);
        // Prevent infinite loop if fallback also fails
        if (event.target.src === fallbackUrl) {
            return;
        }
        // Set fallback URL
        event.target.src = fallbackUrl;
    }

    function handleAudioError(event) {
        // If already using fallback, don't try again
        if (audioUseFallback) return;

        console.warn("audio fallback to url", frontAudio?.url);
        audioUseFallback = true;
    }

    function handleAudioClick(event) {
        // Prevent card flip when clicking on audio controls
        event.stopPropagation();
    }
</script>

<div class="flashcard-wrapper">
    {#if !isFlipped}
        <div class="flashcard bg-primary/5 border-primary/30" on:click={onFlip}>
            <div class="card-label bg-primary text-primary-content">Question</div>
            {#if frontImages && frontImages.length > 0}
                <div class="card-images">
                    {#each frontImages as image}
                        <img
                            src={image.urlCachePWA || image.url}
                            alt="Question"
                            class="card-image"
                            on:error={(e) => handleImageError(e, image.url)}
                        />
                    {/each}
                </div>
            {/if}
            {#if frontAudio && currentAudioUrl}
                <div class="card-audio" on:click={handleAudioClick}>
                    {#key currentAudioUrl}
                        <audio
                            controls
                            preload="metadata"
                            src={currentAudioUrl}
                            on:error={handleAudioError}
                        >
                            Votre navigateur ne supporte pas l'élément audio.
                        </audio>
                    {/key}
                </div>
            {/if}
            <div class="card-content text-base-content">
                {@html sanitizeHtml(frontContent)}
            </div>
            <div class="flip-hint text-base-content/50">
                Cliquez pour voir la réponse
            </div>
        </div>
    {:else}
        <div class="flashcard flashcard-back bg-secondary/5 border-secondary/30" on:click={onFlip}>
            <div class="card-label bg-primary text-primary-content">Réponse</div>
            {#if backImages && backImages.length > 0}
                <div class="card-images">
                    {#each backImages as image}
                        <img
                            src={image.urlCachePWA || image.url}
                            alt="Réponse"
                            class="card-image"
                            on:error={(e) => handleImageError(e, image.url)}
                        />
                    {/each}
                </div>
            {/if}
            <div class="card-content text-base-content">
                {@html sanitizeHtml(backContent)}
            </div>
        </div>
    {/if}
</div>

<style>
    .flashcard-wrapper {
        min-height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .flashcard {
        position: relative;
        width: 100%;
        height: 400px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        border-radius: 12px;
        border: 2px solid;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .flashcard-back {
    }

    .card-label {
        position: absolute;
        top: 1rem;
        left: 1rem;
        padding: 0.4rem 0.8rem;
        border-radius: 6px;
        font-size: 0.85rem;
        font-weight: 600;
        text-transform: uppercase;
    }

    .card-images {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        justify-content: center;
        margin-bottom: 1rem;
        max-width: 100%;
    }

    .card-image {
        max-width: 100%;
        max-height: 150px;
        object-fit: contain;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .card-audio {
        width: 100%;
        max-width: 300px;
        margin-bottom: 1rem;
    }

    .card-audio audio {
        width: 100%;
        height: 40px;
        border-radius: 8px;
    }

    .card-content {
        font-size: 1.5rem;
        line-height: 1.6;
        text-align: center;
        word-wrap: break-word;
        max-width: 100%;
    }

    .flip-hint {
        position: absolute;
        bottom: 1rem;
        font-size: 0.85rem;
        font-style: italic;
    }

    @media (max-width: 640px) {
        .flashcard {
            height: 350px;
        }

        .card-content {
            font-size: 1.2rem;
        }

        .card-image {
            max-height: 120px;
        }
    }
</style>
